import { isUsCitizenProfile } from './workDocumentRules';

// A candidate verifies identity documents in order: a Driver's licence or State ID first, then a
// foreign passport for a candidate who is not a US citizen, then any other document. The server
// refuses a document verified before the ones ahead of it, and the browser tells the candidate why.

// The verification record's status for a document refused for its order.
export const OUT_OF_ORDER_STATUS = 'out_of_order';

// The copy naming the document to verify first, per refusal step.
export const ORDER_STEP_MESSAGE_IDS = {
  licence_first: 'DocumentOrder.licenceFirst',
  passport_first: 'DocumentOrder.passportFirst',
};

// The step a failed save was refused at for its order, or null for any other failure.
export const orderRefusalOf = error =>
  error?.reason === OUT_OF_ORDER_STATUS ? error.step || null : null;

// The Wallet's names for the documents each step waits for.
const LICENCE_DOCUMENT_NAMES = ["Driver's license", 'State ID'];
const FOREIGN_PASSPORT_NAME = 'Foreign Passport';

const isApproved = status => typeof status === 'string' && status.toLowerCase() === 'approved';

// Whether the candidate is a US citizen, decided by the same test the server uses when it decides
// whether a foreign passport is needed. Takes the candidate's work details (country of citizenship
// and work-auth type), or a country of citizenship alone.
export const isUsCitizenship = profileOrCountry =>
  isUsCitizenProfile(
    profileOrCountry && typeof profileOrCountry === 'object'
      ? profileOrCountry
      : { countryOfCitizenship: profileOrCountry }
  );

// Whether the document a refusal step waits for now reads approved, so the refused document can be
// verified again. `statusOf` answers a document's latest status by its Wallet name. A US citizen
// needs no foreign passport, so that step no longer holds them back once they have said so. A step
// this does not know never holds the candidate back; the server decides again when they verify.
export const isOrderStepCleared = (step, statusOf, { usCitizen = false } = {}) => {
  if (step === 'licence_first') return LICENCE_DOCUMENT_NAMES.some(name => isApproved(statusOf(name)));
  if (step === 'passport_first') return usCitizen || isApproved(statusOf(FOREIGN_PASSPORT_NAME));
  return true;
};
